import { ReactComponent as ChartBarSvg } from 'assets/svg/chart-bar.svg';
import { ReactComponent as PictureSvg } from 'assets/svg/picture.svg';
import { ReactComponent as TableSvg } from 'assets/svg/table.svg';
import { ReactComponent as TLetterSvg } from 'assets/svg/tLetter.svg';
import { ButtonVariants } from 'constants/common';
import { BUTTONS_STYLES, BUTTONS_STYLES_MODE } from 'constants/report-document-builder';
import { Button } from 'shared-components';

interface Props {
  isGridVisible: boolean;
  onToggleGrid: (value: boolean) => void;
  toolbarSlotRef?: React.RefObject<HTMLDivElement>;
}

const PageCustomizationBlock = ({ isGridVisible, onToggleGrid, toolbarSlotRef }: Props) => {
  const toggleGrid = () => {
    onToggleGrid(!isGridVisible);
  };

  return (
    <div className="flex items-center justify-between px-5 py-2 h-12 bg-white dark:bg-black-900 border-b border-neutral-200 dark:border-neutral-800">
      <div className="flex gap-2 items-center">
        <Button
          variant={ButtonVariants.OUTLINE}
          className={`${BUTTONS_STYLES} ${isGridVisible && 'border-primary-500 dark:border-primary-500'}`}
          onClick={toggleGrid}
        >
          <span className={BUTTONS_STYLES_MODE(isGridVisible)}>
            <TableSvg />
          </span>
        </Button>
        <div className="w-[1px] h-full bg-neutral-300 dark:border-neutral-700"></div>
        <Button variant={ButtonVariants.OUTLINE} className={BUTTONS_STYLES}>
          <span className="text-black-900 dark:text-white-00">
            <TLetterSvg />
          </span>
        </Button>
        <Button variant={ButtonVariants.OUTLINE} className={BUTTONS_STYLES}>
          <span className="text-black-900 dark:text-white-00">
            <PictureSvg />
          </span>
        </Button>
        <Button variant={ButtonVariants.OUTLINE} className={BUTTONS_STYLES}>
          <span className="text-black-900 dark:text-white-00">
            <ChartBarSvg />
          </span>
        </Button>
        <Button variant={ButtonVariants.OUTLINE} className={BUTTONS_STYLES}>
          <span className="text-black-900 dark:text-white-00">
            <TableSvg />
          </span>
        </Button>
        <div className="w-[1px] h-full ml-2 bg-neutral-300 dark:border-neutral-700"></div>
      </div>
      <div ref={toolbarSlotRef} className="flex items-center gap-2" data-toolbar-slot />
    </div>
  );
};

export default PageCustomizationBlock;
